import React, { useState, useEffect } from 'react';
import './CountdownTimer.css';

const CountdownTimer = ({ targetDate = '2026-07-20', batchStartDate = '2026-08-06' }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    isExpired: false,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const targetDateTime = new Date(targetDate).getTime();
      const now = new Date().getTime();
      const difference = targetDateTime - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          isExpired: false,
        });
      } else {
        setTimeLeft({
          days: 0,
          isExpired: true,
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (timeLeft.isExpired) {
    return (
      <div className="countdown-expired">
        <p className="expired-text">Registration Closing Soon</p>
        <p className="batch-info">Batch starting {batchStartDate}</p>
      </div>
    );
  }

  return (
    <div className="countdown-container">
      <div className="countdown-label">
        <strong>⏰ Registration Closes In:</strong>
      </div>
      <div className="countdown-timer">
        <div className="countdown-item">
          <div className="countdown-value">{String(timeLeft.days).padStart(2, '0')}</div>
          <div className="countdown-unit">Days</div>
        </div>
      </div>
      <p className="batch-start-info">
        🎓 New Batch Starts: <strong>{batchStartDate}</strong>
      </p>
    </div>
  );
};

export default CountdownTimer;
